import AIConfiguration from "@/components/AIConfiguration";

const AIConfigPage = () => (
  <section className="space-y-6">
    <header>
      <h1 className="heading-display text-2xl">AI Configuration</h1>
      <p className="mt-1 text-sm text-muted-foreground">Configure the AI provider and model used by the application.</p>
    </header>
    <AIConfiguration />
  </section>
);

export default AIConfigPage;
